export default "__VITE_ASSET__68a40f9a__"